import React, { Component } from "react";
import { connect } from "react-redux";
import { Dropdown, Menu } from "semantic-ui-react";
import { hasPermission, isLoggedIn } from "../../../reducer";
import { Link } from "react-router-dom";
import { Translate } from "react-localize-redux";


class ToolLinks extends Component {

    render() {

        if (this.props.loggedIn) {

            if (!this.props.hasPermission("tools")) {

                return null;
            }

            if (this.props.mobile) {
                return (
                    <Translate>
                        {({ translate }) =>
                            <Menu.Item>
                                <Menu.Header>Clock</Menu.Header>
                                <Menu.Menu>
                                    {this.props.hasPermission("masterDataManage") &&
                                    <Menu.Item name={translate("tools.links.manageProducts")}
                                               as={Link}
                                               to={"/tools/manageProducts"}/>}
                                    {this.props.hasPermission("masterDataRequests") &&
                                    <Menu.Item name={translate("tools.links.masterDataRequests")}
                                               as={Link}
                                               to={"/tools/masterDataRequest"}/>}
                                    {this.props.hasPermission("masterDataManage") &&
                                    <Menu.Item name={translate("tools.links.manageRequests")}
                                               as={Link}
                                               to={"/tools/manageRequests"}/>}
                                    {this.props.hasPermission("masterDataRequests") &&
                                    <Menu.Item name={translate("tools.links.myRequests")} as={Link}
                                               to={"/tools/myRequests"}/>}
                                    {this.props.hasPermission("masterDataManage") &&
                                    <Menu.Item name={"Procurement"} as={Link}
                                               to={"/tools/procurement"}/>}
                                </Menu.Menu>
                            </Menu.Item>
                        }
                    </Translate>
                );
            }

            return (

                <Translate>
                    {({ translate }) =>
                        <Dropdown item text={translate("tools.header")}>
                            <Dropdown.Menu>
                                {this.props.hasPermission("masterDataManage") &&
                                <Dropdown.Item as={Link}
                                               to={"/tools/manageProducts"}>{translate("tools.links.manageProducts")}</Dropdown.Item>}
                                {this.props.hasPermission("masterDataManage") &&
                                <Dropdown.Item as={Link}
                                               to={"/tools/manageRequests"}>{translate("tools.links.manageRequests")}</Dropdown.Item>}
                                {this.props.hasPermission("masterDataRequests") &&
                                <Dropdown.Item as={Link}
                                               to={"/tools/masterDataRequests"}>{translate("tools.links.masterDataRequests")}</Dropdown.Item>}
                                {this.props.hasPermission("masterDataRequests") &&
                                <Dropdown.Item as={Link}
                                               to={"/tools/myRequests"}>{translate("tools.links.myRequests")}</Dropdown.Item>}
                                {this.props.hasPermission("procurement") && <Dropdown.Item as={Link}
                                                                                           to={"/tools/procurement"}>Procurement</Dropdown.Item>}
                            </Dropdown.Menu>
                        </Dropdown>
                    }
                </Translate>
            );
        }

        return null;
    }
}

const mapStateToProps = state => ({
    loggedIn: isLoggedIn(state),
    hasPermission: (permission) => {
        return hasPermission(state, permission);
    }
});


export default connect(
    mapStateToProps,
    null,
    null
)(ToolLinks);



// WEBPACK FOOTER //
// ./src/scenes/Tools/Links/index.js